export default class UpdateAssetModel {
    organizationId = null;
    assetId = null;
    name = null;
    description = null;
    teamsWebhookUrl = null;
    siteId = null;
    eTag = null;

    constructor(organizationId, assetId, name, description, teamsWebhook, eTag, siteId = null){
        this.organizationId = organizationId;
        this.assetId = assetId;
        this.name = name;
        this.description = description;
        this.teamsWebhookUrl = teamsWebhook;
        this.siteId = siteId;
        this.eTag = eTag;
    }
}
